import React from "react";
import { useTranslation } from "react-i18next";

import { useStyles } from "./Summary.styles";
import Currency from "../../../shared/components/currency/Currency";

interface SummaryProps {
  summary:
    | {
        subtotal: number;
        vat: number;
        deliveryFee: number;
        total: number;
      }
    | undefined;
}

const Summary: React.FC<SummaryProps> = ({ summary }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const { subtotal, vat, deliveryFee, total } = summary || {};

  return (
    <div className={classes.summary}>
      <div className={classes.row}>
        <span className={classes.label}>{t("account.totalBeforeVAT")}</span>
        <span className={classes.value}>
          <Currency />
          {((subtotal ?? 0) / 100).toFixed(2)}
        </span>
      </div>

      <div className={classes.row}>
        <span className={classes.label}>{t("account.VAT")}</span>
        <span className={classes.value}>
          <Currency />
          {((vat ?? 0) / 100).toFixed(2)}
        </span>
      </div>

      <div className={classes.row}>
        <span className={classes.label}>{t("account.delivery")}</span>
        <span className={classes.value}>
          <Currency />
          {((deliveryFee ?? 0) / 100).toFixed(2)}
        </span>
      </div>

      <div className={classes.totalRow}>
        <span className={classes.totalLabel}>{t("common.total")}</span>
        <span className={classes.totalValue}>
          <Currency />
          {((total ?? 0) / 100).toFixed(2)}
        </span>
      </div>
    </div>
  );
};

export default Summary;
